/**
 * Fire-and-forget claim for time-boxed credit-campaign actions that have no
 * natural backend hook (e.g. opening a game — there's no entity created,
 * so the backend can't detect it on its own).
 *
 * Mirrors `_claimIntegrationBonus` in `services/integrations/useUnifiedIntegrations.ts`.
 * The backend (`POST /api/credit-campaigns/claim`) is fully idempotent and
 * validates the action against the currently active campaign, so this is
 * safe to call every time the qualifying client-side event happens.
 */
import { API_BASE_URL } from '../../api/config';

export function claimCreditCampaignAction(actionId: string): void {
  const token = localStorage.getItem('authToken');
  fetch(`${API_BASE_URL}/credit-campaigns/claim`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ action_id: actionId }),
  }).catch(() => {});
}
